/* eslint-disable no-bitwise */
import React from 'react';

import { pos1Won, pos2Won } from '../../../utils/postScore';

const PickleballSetV2 = (props) => {
    const {
        set,
        onInputChange,
    } = props;

    const tabIndex = (scoreType) => {
        const keys = { pos1Score: 1, pos2Score: 2, pos1TieBrk: 3, pos2TieBrk: 4 };
        return (set.id ? `${set.id}${keys[scoreType]}` : keys[scoreType]);
    };

    return (
        <div className="set-column" key={set.id}>
            <div className={`input-wrapper`}>
                <span className="set-label">{`Game ${set.id + 1}`}</span>
                <input
                    type="number"
                    value={set.pos1Score}
                    min="0"
                    max="11"
                    className={`score-box ${!set.pos1Score ? 'dashed' : ''} ${pos1Won(set) ? 'won' : ''}`}
                    onChange={event => onInputChange(set, 'pos1Score', event)}
                    tabIndex={tabIndex('pos1Score')}
                />
            </div>
            <div className={`input-wrapper`}>
                <span className="set-label">{`Game ${set.id + 1}`}</span>
                <input
                    type="number"
                    value={set.pos2Score}
                    min="0"
                    max="11"
                    className={`score-box ${!set.pos2Score ? 'dashed' : ''} ${pos2Won(set) ? 'won' : ''}`}
                    onChange={event => onInputChange(set, 'pos2Score', event)}
                    tabIndex={tabIndex('pos2Score')}
                />
            </div>
        </div>
    );
};

export default PickleballSetV2;
